export function selectedProject(actor:string|undefined):string|undefined{
 if(!actor||typeof sessionStorage==='undefined')return undefined;
 try{const value=sessionStorage.getItem('vuilabs-project:'+actor);return value&&value.length<=36?value:undefined;}catch{return undefined;}
}
export function saveSelectedProject(actor:string,value:string){
 if(value.length>36)throw new Error('项目标识无效');
 if(value)sessionStorage.setItem('vuilabs-project:'+actor,value);else sessionStorage.removeItem('vuilabs-project:'+actor);
}
export function projectFilteredRead(path:string,method:string){
 if(method.toUpperCase()!=='GET')return false;
 const url=new URL(path,'http://local.invalid');
 return (url.pathname.startsWith('/api/v1/platform/')&&!url.pathname.startsWith('/api/v1/platform/access/')&&url.pathname!=='/api/v1/platform/access-mode')||url.pathname.startsWith('/api/v1/blind/admin/');
}
